/**
 * @typedef {Object} FigmaBoundingBox
 * @property {number} x       - X position relative to parent
 * @property {number} y       - Y position relative to parent
 * @property {number} width   - Element width before scaling
 * @property {number} height  - Element height before scaling
 * @property {number} scaleX  - Horizontal scale factor
 * @property {number} scaleY  - Vertical scale factor
 */

/**
 * Raw data payload coming from the Figma parser.
 * Extend this type if more fields are added.
 *
 * @typedef {Object} FigmaElementData
 * @property {FigmaBoundingBox} boundingBox - Position and size information
 * @property {string} name - Position and size information
 * @property {boolean} visible - Position and size information
 */

export class FigmaElement {
  uuid;
  type;
  /**
   * @type {FigmaElementData}
   */
  data;
  
  __originalData;
  
  constructor(data) {
    this.uuid = data.uuid;
    this.type = data.type;
    this.data = data.data;
    
    this.__originalData = data.__originalData;
  }
}
